import { render, staticRenderFns } from "./layout-product-card-preview.vue?vue&type=template&id=36fc9d71&scoped=true&"
import script from "./layout-product-card-preview.vue?vue&type=script&lang=js&"
export * from "./layout-product-card-preview.vue?vue&type=script&lang=js&"
import style0 from "./layout-product-card-preview.vue?vue&type=style&index=0&id=36fc9d71&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fc9d71",
  null
  
)

export default component.exports